export default function toString(
  value: unknown,
  defaultValue: string = ""
): string {
  if (typeof value === "number" && Number.isSafeInteger(value)) {
    return value.toString()
  }

  if (value === undefined || value === null) {
    return defaultValue
  }
  return String(value)
}
